import React from "react";
import Slider from "react-slick";
import {
  Box,
  Grid,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowForwardIos,
  ArrowBackIos,
  Grain,
  LocationOn,
  DesignServices,
  Security,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images
import vegeandspicesbanner from './images/vegeandspicesbanner.avif';
import webdesign from './images/webdesign.jpg'
import webdevelopment from './images/webdev.png'
import logodesign from './images/logo desgin.jpg'
import digitalmarketing from './images/digitalmarketing.jpg'
import pinkOnionFlakeImage from './images/Dehydrated Onion Flakes Supplier, Exporter _ Dehydratedveg_com.jpeg'
import garlicCloveImage from './images/GarlicClove.jpg'
import garlicChoppedImage from './images/GarlicMinced.jpeg'
import garlicMincedImage from './images/how-to-mince-garlic-2171-1.jpg'
import garlicGranulesImage from './images/GarlicGranules.jpg'
import garlicpowderimg from './images/garlicpowder.jpg'
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp'
import pinkOnionChoppedImage from './images/purple-onion-cut-half-pink-strips-visible-against-dark-background-344354882.webp'
import pinkOnionMincedImage from './images/pinkonionminced.jpg'
import pinkOnionPowderImage from './images/pinkonionpowder.jpg'
import whiteOnionFlakeImage from './images/whiteonionflakes.webp'
import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg'
import whiteOnionChoppedImage from './images/dehydrated-white-onion-chopped-500x500.webp'
import whiteOnionMincedImage from './images/dehydrated-white-onion-minced-500x500.webp'
import whiteOnionPowderImage from './images/dehydrated-white-onion-powder.jpg'
import redOnionFlakeImage from './images/redonionflakes.webp'
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg'
import redOnionChoppedImage from './images/red-onion-chopped-2-scaled-500x500.webp'
import redOnionMincedImage from './images/dehydrated-red-onion-minced-500x500.webp'
import redOnionPowderImage from './images/redonionpowder.jpg'
import friedOnionFreshImage from './images/organic-onion-fried-500x500.webp'
import friedCoatedWhiteOnionImage from './images/whitecoatedonion.webp'
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg'
import friedWhiteOnionFlakeImage from './images/friedcoatedmin.jpg'
import friedPinkOnionFlakeImage from './images/friedcoatedmin.jpg'
import gingerFlakeImage from './images/dehydrated-ginger-flakes.jpg'
import gingerPowderImage from './images/113563735.webp'
import greenChilliPowderImage from './images/dehydrated-green-chilli-powder-500x500.webp'
import tamarindPowderImage from './images/tamarind-powder-500x500.webp'
import tomatoPowderImage from './images/toamatopowder.jpg'
import mintPowderImage from './images/mint-leaves-pudina-patta-powder-2nd.jpeg'
import potatoPowderImage from './images/istockphoto-185902790-612x612.jpg'
import spinachPowderImage from './images/spinachpowder.jpg'
import mangoPowderImage from './images/AmchurPowder.webp'
import fenugreekPowderImage from './images/fenugreek-leaf-powder-250x250.webp'
import lemonPowderImage from './images/07_Spray-Dried-Lemon-Powder-600x600.jpg'
import beetrootPowderImage from './images/DriedBeetrootPowder.webp'
import cheesePowderImage from './images/IMG_6946_800x.webp'
import corianderPowderImage from './images/CorianderPowder.webp'
import beetrootImage from './images/istockphoto-493446908-612x612.jpg'
import cabbageImage from './images/istockphoto-544313316-612x612.jpg'
import carrotImage from './images/carrots.jpg'
import tomatoImage from './images/istockphoto-98026003-612x612.jpg'
import gingerImage from './images/istockphoto-162711007-612x612.jpg'
import potatoImage from './images/istockphoto-1346299887-612x612.jpg'
import greenChilliImage  from './images/green-chilli-200-g-product-images-o590000187-p590000187-0-202409251830.webp'

// Components
import Commonredirects from "./Commonredirects";
import FeatureProduct from "./FeatureProduct";

// Theme Colors
const primaryColor = "#1F473E";
const secondaryColor = "#D4C9B6";

// Animation
const floatAnimation = {
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <ArrowForwardIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      right: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const PrevArrow = ({ onClick }) => (
  <ArrowBackIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const DetailedvegetabelAndSpices = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      image: vegeandspicesbanner,
      title: "Vegetable Powders & Spices",
description: "Enhance your culinary creations with our high-quality vegetable powders and spices, crafted from the freshest ingredients to deliver authentic flavors and vibrant aromas in every pinch.",
      buttonText: "Order Now",
    },
  ];


  const gingerFlake = {
  image: gingerFlakeImage,
  features: [
    {
      icon: Grain,
      title: "Ginger Flake",
      description: "Dried ginger flakes. Used in teas, pickles, and spice infusions.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Flakes. Color: Light brown. Aroma: Warm and pungent.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Perfect for adding natural ginger flavor to drinks and condiments.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Popular in traditional teas and pickling recipes.",
    },
  ],
};

const dehydratedBeetroot = {
  image: beetrootImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Beetroot",
      description: "Dried beetroot slices. For soups, salads, and health snacks.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Slices. Color: Vibrant red. Nutritional value retained.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Ideal for soups, salads, and healthy snacks.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Natural, nutrient-rich, and easy to use in various dishes.",
    },
  ],
};

const dehydratedCabbage = {
  image: cabbageImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Cabbage",
      description: "Shredded and dried cabbage. Retains nutritional value and taste.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Shredded. Color: Light green. Texture: Crisp.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Perfect for soups, casseroles, and instant meals.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Maintains fresh taste and nutrition for longer shelf life.",
    },
  ],
};

const dehydratedCarrot = {
  image: carrotImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Carrot",
      description: "Chopped or shredded dried carrots. Used in soups, noodles, and snacks.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Chopped/Shredded. Color: Orange. Flavor: Sweet and earthy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds nutrition and color to various dishes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Long shelf life with preserved flavor and nutrients.",
    },
  ],
};

const dehydratedTomato = {
  image: tomatoImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Tomato",
      description: "Dried tomato flakes or slices. For instant soups and sauces.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Flakes/Slices. Color: Red. Taste: Tangy and rich.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Perfect for quick cooking and flavor enhancement.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Convenient and shelf-stable tomato ingredient.",
    },
  ],
};

const dehydratedGinger = {
  image: gingerImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Ginger",
      description: "Sliced or chopped ginger root. Spicy and aromatic for teas and dishes.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Sliced/Chopped. Color: Pale yellow. Aroma: Strong and spicy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds warmth and zest to culinary and medicinal uses.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Used widely in teas, spice blends, and cooking.",
    },
  ],
};

const dehydratedPotato = {
  image: potatoImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Potato",
      description: "Dried potato chunks or slices. Shelf-stable, quick to rehydrate.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Chunks/Slices. Color: Off-white. Texture: Firm.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Ideal for snacks, instant meals, and baking.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Quick cooking with maintained flavor and nutrition.",
    },
  ],
};

const dehydratedGreenChilli = {
  image: greenChilliImage,
  features: [
    {
      icon: Grain,
      title: "Dehydrated Green Chilli",
      description: "Hot green chili in dried form. Used in pickles, snacks, and seasonings.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Whole/Chopped. Color: Green. Flavor: Spicy and pungent.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds heat and flavor to various culinary preparations.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Essential spice ingredient with long shelf life.",
    },
  ],
};


const gingerPowder = {
  image: gingerPowderImage,
  features: [
    {
      icon: Grain,
      title: "Ginger Powder",
      description: "Finely ground ginger. For baking, spice blends, and masalas.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Pale yellow. Aroma: Sharp and spicy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds heat and flavor depth to baked goods and curry powders.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Widely used in spice blends and masalas across cuisines.",
    },
  ],
};

const greenChilliPowder = {
  image: greenChilliPowderImage,
  features: [
    {
      icon: Grain,
      title: "Green Chilli Powder",
      description: "Hot green chili powder. Spicy addition to chutneys and marinades.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Green. Heat: Medium to high.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds fresh chili heat and color to dishes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Essential in Indian, Thai, and Mexican recipes for spice.",
    },
  ],
};

const tamarindPowder = {
  image: tamarindPowderImage,
  features: [
    {
      icon: Grain,
      title: "Tamarind Powder",
      description: "Tangy powdered tamarind. Great for spice mixes, chutneys, and Indian snacks.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Brown. Flavor: Tangy and sour.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds tanginess to snacks and spice blends.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Used extensively in Indian and Southeast Asian cuisines.",
    },
  ],
};

const tomatoPowder = {
  image: tomatoPowderImage,
  features: [
    {
      icon: Grain,
      title: "Tomato Powder",
      description: "Spray-dried tomato powder. Perfect for soups, pastas, and seasonings.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Red. Flavor: Sweet and tangy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds authentic tomato flavor and color to sauces and mixes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Convenient shelf-stable tomato ingredient.",
    },
  ],
};

const mintPowder = {
  image: mintPowderImage,
  features: [
    {
      icon: Grain,
      title: "Mint Leaves Powder",
      description: "Cool mint flavor in powdered form. Enhances chutneys and curd-based dishes.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Green. Aroma: Fresh and cool.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds refreshing mint aroma and taste to dishes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Popular in raitas, chutneys, and salads.",
    },
  ],
};

const potatoPowder = {
  image: potatoPowderImage,
  features: [
    {
      icon: Grain,
      title: "Potato Powder",
      description: "Dehydrated potato in powder form. Used in snacks, bakery, and instant foods.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Off-white. Texture: Fine and smooth.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds body and texture to instant snacks and bakery items.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Used in instant soups, snack mixes, and bakery doughs.",
    },
  ],
};

const spinachPowder = {
  image: spinachPowderImage,
  features: [
    {
      icon: Grain,
      title: "Spinach Powder",
      description: "Nutrient-rich spinach powder. Used in smoothies, soups, and bakery items.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Dark green. Nutrients: High in iron and vitamins.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds natural color and nutrients to food preparations.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Used in health foods and natural colorants.",
    },
  ],
};

const mangoPowder = {
  image: mangoPowderImage,
  features: [
    {
      icon: Grain,
      title: "Dry Mango Powder",
      description: "Tangy amchur powder. Used in chutneys, pickles, and curries.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Light brown. Flavor: Sour and fruity.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds sourness and fruity tang to dishes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Key ingredient in Indian spice mixes and pickles.",
    },
  ],
};

const fenugreekPowder = {
  image: fenugreekPowderImage,
  features: [
    {
      icon: Grain,
      title: "Fenugreek Leaves Powder",
      description: "Kasuri methi in powdered form. Adds aroma to Indian gravies and parathas.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Greenish-brown. Aroma: Strong and earthy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Used for flavoring gravies, breads, and curries.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Widely used in North Indian cuisine for distinct aroma.",
    },
  ],
};

const lemonPowder = {
  image: lemonPowderImage,
  features: [
    {
      icon: Grain,
      title: "Lemon Powder",
      description: "Sour citrus powder. Adds tangy zest to seasonings and beverages.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Pale yellow. Flavor: Citrusy and sour.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Enhances flavor in drinks, spice blends, and snacks.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Ideal for seasoning mixes and natural beverages.",
    },
  ],
};

const beetrootPowder = {
  image: beetrootPowderImage,
  features: [
    {
      icon: Grain,
      title: "Beetroot Powder",
      description: "Vibrant red beet powder. Used in juices, snacks, and natural coloring.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Deep red. Nutrients: Rich in antioxidants.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Natural colorant and nutrient booster in food.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Used in health drinks and natural snack coatings.",
    },
  ],
};

const cheesePowder = {
  image: cheesePowderImage,
  features: [
    {
      icon: Grain,
      title: "Cheese Powder",
      description: "Savory cheese flavor in powdered form. Ideal for pasta, popcorn, and snack foods.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Yellowish. Flavor: Savory and cheesy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Adds creamy cheese flavor to snacks and ready mixes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Popular in snack coatings and seasoning blends.",
    },
  ],
};

const corianderPowder = {
  image: corianderPowderImage,
  features: [
    {
      icon: Grain,
      title: "Coriander Leaves Powder",
      description: "Dhaniya leaf powder. Adds freshness and flavor to dals and curries.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description: "Form: Powder. Color: Light green. Aroma: Fresh and citrusy.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description: "Used as a finishing touch in Indian dishes for aroma.",
    },
    {
      icon: Security,
      title: "About the Product",
      description: "Widely used in Indian and Middle Eastern cuisines.",
    },
  ],
};

  










  return (
    <>
      {/* Hero Slider */}
      <Box sx={{ width: "100%", height: "90vh", overflow: "hidden", position: "relative" }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box
              key={index}
              sx={{
                height: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `url(${slide.image}) center/cover no-repeat`,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "rgba(31, 71, 62, 0.3)",
                  color: secondaryColor,
                  padding: "20%",
                  borderRadius: "10px",
                  textAlign: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h2" sx={{ fontFamily: "'Playfair Display', serif", fontWeight: "bold", mb: 2 }}>
                    {slide.title}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h5" sx={{ fontFamily: "'Playfair Display', serif", mb: 3 }}>
                    {slide.description}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: secondaryColor, color: primaryColor, fontWeight: "bold" }}
                  >
                    {slide.buttonText}
                  </Button>
                </motion.div>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>

      {/* Product Details Section */}
     <FeatureProduct data={gingerFlake} title={"Ginger Flake"} />
<FeatureProduct data={gingerPowder} title={"Ginger Powder"} />
<FeatureProduct data={greenChilliPowder} title={"Green Chilli Powder"} />
<FeatureProduct data={tamarindPowder} title={"Tamarind Powder"} />
<FeatureProduct data={tomatoPowder} title={"Tomato Powder"} />
<FeatureProduct data={mintPowder} title={"Mint Leaves Powder"} />
<FeatureProduct data={potatoPowder} title={"Potato Powder"} />
<FeatureProduct data={spinachPowder} title={"Spinach Powder"} />
<FeatureProduct data={mangoPowder} title={"Dry Mango Powder"} />
<FeatureProduct data={fenugreekPowder} title={"Fenugreek Leaves Powder"} />
<FeatureProduct data={lemonPowder} title={"Lemon Powder"} />
<FeatureProduct data={beetrootPowder} title={"Beetroot Powder"} />
<FeatureProduct data={cheesePowder} title={"Cheese Powder"} />
<FeatureProduct data={corianderPowder} title={"Coriander Leaves Powder"} />
<FeatureProduct data={dehydratedBeetroot} title={"Dehydrated Beetroot"} />
<FeatureProduct data={dehydratedCabbage} title={"Dehydrated Cabbage"} />
<FeatureProduct data={dehydratedCarrot} title={"Dehydrated Carrot"} />
<FeatureProduct data={dehydratedTomato} title={"Dehydrated Tomato"} />
<FeatureProduct data={dehydratedGinger} title={"Dehydrated Ginger"} />
<FeatureProduct data={dehydratedPotato} title={"Dehydrated Potato"} />
<FeatureProduct data={dehydratedGreenChilli} title={"Dehydrated Green Chilli"} />
    

      <Commonredirects />
    </>
  );
};

export default DetailedvegetabelAndSpices;
